import React from 'react';
import { TableFilterOperatorsEnum, TableFilterTypesEnum } from '../../../Enums';
import ShowMore from '../../../SharedComponents/ShowMore/ShowMore';
import { PaymentPlansLocalePath } from './i18n/PaymentPlansLocale';

const isCorrectLocation = () => {
  const pathname = window.location.pathname;
  return (
    pathname === '/home/units-sales/unit-profile-edit' ||
    pathname === '/home/units-lease/unit-profile-edit' ||
    pathname === '/home/lead-owner-units-sale/unit-profile-edit'
  );
};

export const paymentPlanHeaderData = [
  {
    label: 'plan_name',
    input: 'paymentPlanName',
    filterType: TableFilterTypesEnum.textInput.key,
    withoutOperators: true,
    cellClasses: (item) =>
      item?.allowSelectPaymentPlan === false && isCorrectLocation()
        ? 'payment-plan-disabled'
        : '',
  },
  {
    label: 'down_payment',
    input: 'downPayment',
    filterType: TableFilterTypesEnum.numberInput.key,
    operators: [
      {
        key: TableFilterOperatorsEnum.equal.key,
      },
      {
        key: TableFilterOperatorsEnum.lessThan.key,
      },
      {
        key: TableFilterOperatorsEnum.greaterThan.key,
      },
    ],
    textInputType: 'number',
    inputPlaceholder: '%',
    cellClasses: (item) =>
      item?.allowSelectPaymentPlan === false && isCorrectLocation()
        ? 'payment-plan-disabled'
        : '',
  },
  {
    label: 'monthly_installment',
    input: 'monthlyInstallment',
    component: (row) => (
      <ShowMore
        text={row.monthlyInstallment}
        title={'installments'}
        parentTranslationPath={PaymentPlansLocalePath}
      />
    ),
    cellClasses: (item) =>
      item?.allowSelectPaymentPlan === false && isCorrectLocation()
        ? 'payment-plan-disabled'
        : '',
  },
  {
    label: 'handover_payment',
    input: 'handoverPayment',
    searchableKey: 'handoverInstallment',
    filterType: TableFilterTypesEnum.numberInput.key,
    operators: [
      {
        key: TableFilterOperatorsEnum.equal.key,
      },
      {
        key: TableFilterOperatorsEnum.lessThan.key,
      },
      {
        key: TableFilterOperatorsEnum.greaterThan.key,
      },
    ],
    textInputType: 'number',
    inputPlaceholder: '%',
    cellClasses: (item) =>
      item?.allowSelectPaymentPlan === false && isCorrectLocation()
        ? 'payment-plan-disabled'
        : '',
  },
  {
    label: 'post_handover',
    input: 'postHandover',
    cellClasses: (item) =>
      item?.allowSelectPaymentPlan === false && isCorrectLocation()
        ? 'payment-plan-disabled'
        : '',
  },
  {
    label: 'specific_developer',
    input: 'specificDeveloper',
    component: (row) =>
      row.paymentPlanDevelopers
        ?.map((developer) => developer.developerName)
        .join(', ') || 'General',
    filterType: TableFilterTypesEnum.textInput.key,
    withoutOperators: true,
    searchableKey: 'developerName',
    cellClasses: (item) =>
      item?.allowSelectPaymentPlan === false && isCorrectLocation()
        ? 'payment-plan-disabled'
        : '',
  },
  {
    label: 'status',
    input: 'statusName',
    filterType: TableFilterTypesEnum.selectOption.key,
    searchableKey: 'propertyPlanStatus',
    optionFilterList: [
      { key: 1, value: 'Active' },
      { key: 2, value: 'Inactive' },
    ],
    cellClasses: (item) =>
      item?.allowSelectPaymentPlan === false && isCorrectLocation()
        ? 'payment-plan-disabled'
        : '',
  },
];

export const propertyPaymentPlanHeaderData = paymentPlanHeaderData.filter(
  (item) => item.input !== 'specificDeveloper'
);

export const paymentPlansFilterData = paymentPlanHeaderData.map((item) => ({
  ...item,
  displayPath: item.searchableKey ?? item.input,
  searchableKey: item.searchableKey ?? item.input,
  component: undefined,
}));

export const propertyPaymentPlanFilterData = paymentPlansFilterData.filter(
  (item) => item.input !== 'specificDeveloper'
);
